import React, { useState } from 'react';
import API from '../services/api';

// Shared modal for emailing a client a secure address-update link.
// `sendPath`: '/therapist/address-update/generate' or '/forms/address-update/generate'.
// `client` needs { id, client_name, email }.
export default function AddressUpdateLinkModal({ client, sendPath, onClose }) {
  const [email, setEmail] = useState(client.email || '');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const send = async () => {
    if (!email.trim()) {
      setError('Client email is required.');
      return;
    }
    setSending(true);
    setError('');
    try {
      await API.post(sendPath, { clientId: client.id, email: email.trim(), message: message.trim() });
      setSent(true);
    } catch (err) {
      console.error('Error sending address-update link:', err);
      setError(err.response?.data?.message || 'Error sending the link.');
      setSending(false);
    }
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={boxStyle} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 2px' }}>Send Address-Update Link</h3>
        <div style={{ color: 'var(--text-muted)', fontSize: 13.5, marginBottom: 10 }}>
          {client.client_name} gets a secure one-time link to update their
          address, phone, and email on file.
        </div>

        {sent ? (
          <div style={{ padding: '10px 0' }}>
            <p style={{ color: '#065F46', fontWeight: 700, margin: '4px 0' }}>Link sent!</p>
            <p style={{ fontSize: 14, margin: '4px 0' }}>
              It expires in 7 days. You can track it on the Sent Links page.
            </p>
            <div style={{ textAlign: 'right', marginTop: 10 }}>
              <button style={primaryBtnStyle} onClick={onClose}>Done</button>
            </div>
          </div>
        ) : (
          <>
            <label style={labelStyle}>Client Email</label>
            <input
              style={inputStyle} value={email} onChange={(e) => setEmail(e.target.value)}
              type="email" autoComplete="off"
            />
            <label style={labelStyle}>Message (optional)</label>
            <textarea
              style={{ ...inputStyle, resize: 'vertical' }} rows={3}
              value={message} onChange={(e) => setMessage(e.target.value)}
              placeholder="e.g. Congrats on the new place! Please update your address when you have a minute."
            />
            {error && <div style={{ color: 'var(--error-color)', fontSize: 13.5, marginTop: 6 }}>{error}</div>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 14 }}>
              <button style={cancelBtnStyle} onClick={onClose}>Cancel</button>
              <button
                style={{ ...primaryBtnStyle, opacity: sending ? 0.6 : 1 }}
                onClick={send} disabled={sending}
              >
                {sending ? 'Sending…' : 'Send Link'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: 16,
};
const boxStyle = {
  background: 'var(--white)', borderRadius: 14, padding: '18px 20px', width: '100%',
  maxWidth: 420, boxShadow: '0 16px 48px rgba(0,0,0,0.35)',
};
const labelStyle = { display: 'block', fontSize: 11.5, fontWeight: 600, color: 'var(--text-strong)', margin: '10px 0 3px' };
const inputStyle = {
  width: '100%', boxSizing: 'border-box', padding: '8px 10px', fontSize: 14,
  border: '1px solid var(--border-color)', borderRadius: 6, fontFamily: 'inherit',
};
const cancelBtnStyle = {
  background: 'var(--surface-muted)', color: 'var(--text-color)', border: 'none',
  borderRadius: 6, padding: '8px 14px', fontWeight: 600, cursor: 'pointer',
};
const primaryBtnStyle = {
  background: 'var(--primary-color)', color: '#fff', border: 'none',
  borderRadius: 6, padding: '8px 14px', fontWeight: 700, cursor: 'pointer',
};
